export interface ConfiguracaoEmpresa {
  id: string
  cnpj: string
  inscricaoEstadual: string
  razaoSocial: string
  nomeFantasia: string
  logradouro: string
  numero: string
  complemento: string
  bairro: string
  cep: string
  codigoMunicipio: number
  municipio: string
  uf: string
  codigoPais: number
  pais: string
  telefone: number | null
  crt: number
  serie: number
}

export interface ConfiguracaoFiscalCfop {
  id: string
  cfopOrigem: number
  cfopDestino: number
}

export interface ConfiguracaoFiscalAcao {
  id: string
  tipoAcao: number
  tipoAcaoDescricao: string
  origemMercadoria: number
  icmsCsosn: string
  icmsCst: string
  icmsAliquota: number | null
  icmsReducaoBaseCalculo: number | null
  ipiCst: string
  ipiCodigoEnquadramento: string
  ipiAliquota: number | null
  pisCst: string
  pisAliquota: number | null
  cofinsCst: string
  cofinsAliquota: number | null
  // IBS/CBS (reforma tributaria) - somente na acao Autorizar.
  ibsCbsCst: string | null
  ibsCbsClassTrib: string | null
  ibsUfAliquota: number | null
  ibsMunAliquota: number | null
  cbsAliquota: number | null
  // CFOP da venda (acao Autorizar): escolha direta, nao conversao.
  cfopInterna: number | null
  cfopInterestadual: number | null
  conversoesCfop: ConfiguracaoFiscalCfop[]
}

// Espelha ETipoAcaoFiscal no backend
export const TIPO_ACAO_FISCAL: Record<number, string> = {
  1: 'Autorizar',
  2: 'Devolução Pessoa Física',
  3: 'Devolução Fornecedor'
}
